import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 20h-16v-16h16","key":"svg-0"}],["path",{"d":"M4 20l16 -16","key":"svg-1"}],["path",{"d":"M4 12l8 -8","key":"svg-2"}],["path",{"d":"M12 12l8 8","key":"svg-3"}]]

const IconBrandKotlin = createReactComponent('outline', 'brand-kotlin', 'BrandKotlin', __iconNode);

export default IconBrandKotlin;